/* eslint-disable */
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableFooter,
} from '@material-ui/core';
import { CurrencyFormatter } from '../Utils/CurrencyFormatter';
const WidgeTwoColumns = ({ data }) => {

  const boldStyle = () => ({
    fontWeight: 700, // 700 para negrita, 400 para normal
    color: '#024788', // Azul si es negrita, negro si no
    padding: '15px 16px'
    //fontSize: isBold ? 'larger' : 'inherit', // Tamaño de fuente más grande si es negrita
  });

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index}>
              <TableCell style={{color: 'black', padding: '15px 16px'}}>{item.name}</TableCell>
              <TableCell align="right" style={boldStyle()}><CurrencyFormatter value={item.value} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WidgeTwoColumns;
